<template>
  <access-control :lendflow="true" :clients="true">
    <test-mode-modal v-if="showModal" :close="() => (showModal = false)" />
    <sidebar-button
      v-if="props.testMode"
      :sidebar-expanded="sidebarExpanded"
      class="relative"
      :tooltip-label="$t('ORGANIZATION.TEST_MODE.TITLE')"
      inset-button
      inset-color="bg-secondary-purple hover:opacity-95"
      @click.prevent="showModal = true"
    >
      <template #icon>
        <div class="flex h-10 w-10 justify-center">
          <icon-base
            class="place-self-center"
            height="24"
            width="24"
            viewBox="0 0 20 20"
            :icon="IconSandboxWhite"
            icon-color="white"
            opacity="1"
          />
        </div>
      </template>
      <template #label>
        <div class="flex flex-col items-start justify-between">
          <span class="text-xs font-semibold">
            {{ $t("ORGANIZATION.TEST_MODE.TITLE") }}
          </span>
          <span
            class="rounded-xs bg-secondary-green px-1 text-xxs font-bold uppercase"
          >
            Go Live
          </span>
        </div>
      </template>
    </sidebar-button>
  </access-control>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useStore } from "vuex";

import SidebarButton from "@/components/sidebar/SidebarButton.vue";
import TestModeModal from "@/components/sidebar/TestModeModal.vue";
import IconSandboxWhite from "@/components/icons/IconSandboxWhite.vue";

const props = defineProps({
  testMode: {
    type: Boolean,
    default: false,
  },
});

const { getters } = useStore();
const settings = computed(() => getters["options/settings"]);
const sidebarExpanded = ref<boolean>(
  settings.value.dashboardMenuExpanded ?? true
);
const showModal = ref(false);
</script>
